import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { content } from 'src/environments/data';
import { User } from './shared/interfaces/user.interface';

/**
 * Hard-stonewall stuck users (role 'u' && signup_complete === false — authenticated via
 * voice / Google / password 1FA but never finished registering) onto the /register Role
 * Selection screen. Picking a role there prefills the saved server draft (SignupComponent).
 * Only signup / login / password / signout routes stay reachable.
 */
export const signupIncompleteGuard: CanActivateFn = (_route, state) => {
  const raw = inject(CookieService).get('ddnsession');
  if (!raw) {
    return true;
  }
  let user: User;
  try {
    user = JSON.parse(raw) as User;
  } catch {
    return true;
  }
  if (!user?.token || user.role !== 'u' || user.signup_complete !== false) {
    return true;
  }
  if (isExempt(normalizePath(state.url))) {
    return true;
  }
  return inject(Router).createUrlTree(['/' + content.WEBDDN_SIGNUP_PATH]);
};

function normalizePath(url: string): string {
  return url.split('?')[0].split('#')[0] || '/';
}

function isExempt(path: string): boolean {
  const prefixes = [
    '/' + content.WEBDDN_SIGNUP_PATH,
    '/' + content.WEBDDN_LOGIN_PATH,
    '/forgot-password',
    '/reset-password',
    '/signout',
    '/logout',
  ];
  return prefixes.some((p) => path === p || path.startsWith(p + '/'));
}
